<template>
  <div class="apply_box">
    <div class="header">
      <div class="img">
        <span class="logo_succ"
              :class="{'logo_fail':list.status==150}"></span>
      </div>
      <p class="title">{{list.title}}</p>
      <div class="btn_box">
        <p class="info pd">{{list.content}}</p>
      </div>
    </div>
    <div class="">
      <div class="pro_detail">
        <div class="pro_item bb">
          <h1 class="h1"><span class="line"></span> 订单详情</h1>
        </div>
        <div class="pro_item">
          <p>金额</p>
          <p>{{list.ammount}}</p>
        </div>
        <div class="pro_item">
          <p>期限</p>
          <p>{{list.stage}}期</p>
        </div>
      </div>
    </div>

    <p class="btn"
       @click="getDetails1()">再次申请</p>

    <Loading :isShow="isShowLoading"></Loading>
  </div>
</template>

<script>
import Loading from '@/components/loading';
export default {
  components: {
    Loading
  },
  data () {
    return {
      isShowLoading: false,
      orderId: '',
      list: {},
      isClickBtn: 1,
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('我的-查看详情');
    this.getDetails();
  },
  methods: {
    getDetails () {
      let _this = this;
      this.$get('/app/api/v1/reapply/' + this.orderId)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            if (e.data.pageUrl) {//有pageUrl则跳走
              window.location.href = e.data.pageUrl;
            } else {
              this.util.title(e.data.productName);
              this.list = e.data;
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    getDetails1 () {
      this.isShowLoading = true;
      let _this = this;
      this.isClickBtn = 0;
      let param = {
        orderId: this.orderId
      }
      this.$post('/app/api/v1/reapply/', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            // 成功：关闭当前页
            _this.util.toast({ msg: e.message, duration: 3000 })
            _this.isShowLoading = false;
            setTimeout(() => {
              _this.toPage();
            }, 3000)
          }
          else {
            _this.util.toast({ msg: e.message })
            _this.isShowLoading = false;
            // 跳到详情页面
            _this.toLoanMoney();
          }
          _this.isShowLoading = false;
        })
        .catch(error => { });
    },
    toPage () {
      this.$router.push({
        path: '/loan/applyStatus?orderType=3'
      })
    },
    toLoanMoney (pageUrl) {
      let param = {
        pageUrl: pageUrl
      }
      if (pageUrl.indexOf("http") == "-1") {
        //跳到客户端页面——产品详情页面
        try {
          window.webkit.messageHandlers.toProductDetail.postMessage(param);//ios
        } catch (err) {
          window.AppJs.toProductDetail(JSON.stringify(param));//android
        }
      } else {
        window.location.href = pageUrl;
      }
    }
  }
}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.ft {
  font-size: 0.14rem;
}
.pro_detail {
  background: #ffffff;
  margin-top: 0.1rem;
}
.header {
  padding: 0.3rem 0 0.22rem 0;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
  position: relative;
}

.pd {
  padding-bottom: 0.18rem;
}
.top_bg {
  position: relative;
  top: 0.035rem;
  width: 65%;
  height: 3px;
  background: url('../../assets/img/afterLoan/bg1.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  /* background: #e8eaec; */
}
.succ_bg_act {
  position: absolute;
  background: url('../../assets/img/afterLoan/11@3x.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  width: 65%;
  /* background: #486cff; */
  z-index: 1;
  left: 17%;
  height: 3px;
  top: 0.34rem;
}
.ws13 {
  width: 13.5%;
}
.ws40 {
  width: 40%;
  background: url('../../assets/img/afterLoan/width2.png') no-repeat top center;
  background-size: 100% 100%;
}
.img {
  text-align: center;
  margin-top: 0.2rem;
}
.img_icon,
.img_icon1,
.img_icon2,
.img_icon3,
.img_icon4,
.img_icon5 {
  display: inline-block;
  width: 1.09rem;
  height: 0.9rem;
  background: url('../../assets/img/afterLoan/status0.png') no-repeat top center;
  background-size: 100% 100%;
}
.logo_succ,
.logo_fail {
  display: block;
  width: 0.99rem;
  height: 0.85rem;
  background: url('../../assets/img/afterLoan/rep_succ.png') no-repeat center
    center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.logo_fail {
  background: url('../../assets/img/afterLoan/logo_fail.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.img_icon1 {
  background: url('../../assets/img/afterLoan/status1.png') no-repeat top center;
  background-size: 100% 100%;
}
.img_icon2 {
  background: url('../../assets/img/afterLoan/status2.png') no-repeat top center;
  background-size: 100% 100%;
}
.img_icon3 {
  background: url('../../assets/img/afterLoan/status3.png') no-repeat top center;
  background-size: 100% 100%;
}
.img_icon4 {
  background: url('../../assets/img/afterLoan/status4.png') no-repeat top center;
  background-size: 100% 100%;
}
.img_icon5 {
  background: url('../../assets/img/afterLoan/status5.png') no-repeat top center;
  background-size: 100% 100%;
}
.ws66 {
  width: 66%;
}
.ws65 {
  width: 65.5%;
  background: url('../../assets/img/afterLoan/width3.png') no-repeat top center;
  background-size: 100% 100%;
}
.de_icon,
.ing_icon,
.succ_icon {
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  background: url('../../assets/img/afterLoan/default1.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.succ_icon {
  background: url('../../assets/img/afterLoan/succ1.png') no-repeat top center;
  background-size: 100% 100%;
}

.ing_icon {
  background: url('../../assets/img/afterLoan/ing1.png') no-repeat top center;
  background-size: 100% 100%;
}
.succ_bg .item {
  margin-top: -0.1rem;
  text-align: center;
}
.title {
  color: #333;
  font-size: 0.16rem;
  text-align: center;
  margin-bottom: 0.08rem;
}
.info {
  font-size: 0.16rem;
  color: #999;
  text-align: center;
  margin-top: 0.1rem;
  width: 2.12rem;
  margin: 0 auto;
  text-align: center;
}
.pro_item {
  padding: 0.14rem;
  color: #666;
  /* border-bottom: 1px solid #eee; */
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.pro_item p {
  font-size: 0.14rem;
  color: #666;
}
.bb {
  border-bottom: 1px solid #eee;
}
.h1 {
  font-size: 0.14rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.btn {
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;

  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.4rem;
}
</style>